const AbsencesTab = ({ absences, setShowAbsenceModal, darkMode }) => {
  const getTypeLabel = (type) => {
    const labels = {
      'vacation': 'Férias',
      'férias': 'Férias',
      'ferias': 'Férias',
      'sick_leave': 'Baixa Médica',
      'medical': 'Consulta Médica',
      'personal': 'Assunto Pessoal',
      'bereavement': 'Luto',
      'parental': 'Parental',
      'marriage': 'Casamento',
      'other': 'Outro'
    };
    return labels[type?.toLowerCase()] || type || 'Ausência';
  };

  const getTypeIcon = (type) => {
    const icons = {
      'vacation': '🏖️',
      'férias': '🏖️',
      'sick_leave': '🏥',
      'medical': '👨‍⚕️',
      'bereavement': '🕯️'
    };
    return icons[type] || '📅';
  };

  const getStatusConfig = (status) => {
    const configs = {
      'pending': { label: 'Pendente', color: darkMode ? 'bg-amber-900/30 text-amber-400' : 'bg-amber-100 text-amber-700' },
      'manager_approved': { label: 'Aprovado (Chefia)', color: darkMode ? 'bg-blue-900/30 text-blue-400' : 'bg-blue-100 text-blue-700' },
      'hr_approved': { label: 'Aprovado', color: darkMode ? 'bg-emerald-900/30 text-emerald-400' : 'bg-emerald-100 text-emerald-700' },
      'approved': { label: 'Aprovado', color: darkMode ? 'bg-emerald-900/30 text-emerald-400' : 'bg-emerald-100 text-emerald-700' },
      'rejected': { label: 'Rejeitado', color: darkMode ? 'bg-red-900/30 text-red-400' : 'bg-red-100 text-red-700' },
      'cancelled': { label: 'Cancelado', color: darkMode ? 'bg-slate-700/50 text-slate-400' : 'bg-slate-200 text-slate-600' }
    };
    return configs[status] || { label: status, color: darkMode ? 'bg-slate-700/50 text-slate-300' : 'bg-slate-200 text-slate-600' };
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h3 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Minhas Ausências</h3>
        <button
          onClick={() => setShowAbsenceModal(true)}
          className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors flex items-center gap-2"
          data-testid="new-absence-btn"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Novo Pedido
        </button>
      </div>
      
      {absences.length === 0 ? (
        <div className="text-center py-12">
          <span className="text-5xl block mb-4">📅</span>
          <p className={`mb-2 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem pedidos de ausência</p>
          <p className={`text-sm ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Clique em &quot;Novo Pedido&quot; para solicitar férias ou ausências</p>
        </div>
      ) : (
        <div className="space-y-3">
          {absences.map((absence, idx) => {
            const status = getStatusConfig(absence.status);
            const startDate = absence.start_date || absence.date;
            const endDate = absence.end_date;
            const totalDays = absence.total_days || 1;
            
            return (
              <div key={absence.absence_id || idx} className={`p-4 rounded-lg border ${darkMode ? 'bg-slate-700/30 border-slate-600' : 'bg-white border-slate-200'}`}>
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="text-xl">{getTypeIcon(absence.absence_type)}</span>
                    <span className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{getTypeLabel(absence.absence_type)}</span>
                  </div>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${status.color}`}>
                    {status.label}
                  </span>
                </div>
                
                <div className="grid md:grid-cols-3 gap-2 mb-2">
                  <div>
                    <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Data Início</p>
                    <p className={`text-sm font-medium ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>{startDate}</p>
                  </div>
                  <div>
                    <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Data Fim</p>
                    <p className={`text-sm font-medium ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>{endDate || startDate}</p>
                  </div>
                  <div>
                    <p className={`text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>Total Dias</p>
                    <p className={`text-sm font-medium ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>{totalDays} dia{totalDays > 1 ? 's' : ''}</p>
                  </div>
                </div>
                
                {(absence.reason || absence.justification) && (
                  <p className={`text-sm mt-2 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                    {absence.reason || absence.justification}
                  </p>
                )}
                
                {absence.notes && (
                  <p className={`text-xs mt-1 italic ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                    Notas: {absence.notes}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AbsencesTab;
